import React from 'react';
import { useParams } from 'react-router-dom';
import { AccordionWrapper, CommentsWrapper } from 'react-lib/dist/components-es';
import { useTranslation } from 'react-i18next';
import usePostComment from '@api/comment/hooks/usePostComment';
import useGetComments from '@api/comment/hooks/useGetComments';

function CommentsContainer() {
  const params = useParams();
  const postComment = usePostComment();
  const { comments } = useGetComments(Number(params.uploadId), {
    enabled: params.uploadId !== undefined && !Number.isNaN(params.uploadId),
  });
  const { t } = useTranslation();

  const addComment = (comment: string[]) => {
    postComment({
      comment: comment[0],
      uploadId: Number(params.uploadId!),
    });
  };

  if (!comments) {
    return null;
  }

  return (
    comments && (
      <AccordionWrapper
        accordionTitle={t('report.details.comments.title')}
        className="containerReducedWhiteSpace"
        render={() => (
          <div className="actionCommentsContainer">
            <CommentsWrapper
              comments={comments}
              canAddComment
              inContainer
              saveCommentAction={(comment: string[]) => addComment(comment)}
              t={t}
            />
          </div>
        )}
      />
    )
  );
}

export default CommentsContainer;
